<template>
  <div class="detail-bg">
    <!-- Banner区域，含logo、标题、搜索 -->
    <div class="detail-banner">
      <!-- Banner背景图片 -->
      <div class="banner-bg"></div>
      <div class="banner-inner">
        <!-- <img class="logo" src="../../../assets/images/logo_jk.png" alt="logo" />
        <div class="banner-center">
          <div class="banner-title">建投法审知识库</div>
          <div class="banner-search-row">
            <div class="search-group">
              <el-input
                class="banner-search"
                placeholder="请输入标题或要素进行搜索"
                v-model="searchText"
                :border="false"
              />
              <button class="search-btn">搜索</button>
            </div>
            <button class="advanced-btn">高级搜索</button>
          </div>
        </div> -->
      </div>
    </div>
    <!-- 内容区：两个卡片 -->
    <div class="detail-main" v-loading="isLoading">
      <!-- 第一个卡片 -->
      <div class="card meta-card">
        <el-row>
          <el-col :span="12">
            <span>法律效力阶位：</span>
            <span>{{ formatPopoverValue(docManage.lawRankName) }}</span>
          </el-col>
          <el-col :span="12">
            <span>施行日期：</span>
            <span>{{ formatPopoverValue(docManage.applyDate) }}</span>
          </el-col>
          <el-col :span="12">
            <span>制定机关：</span>
            <span>{{ formatPopoverValue(docManage.issueUnit) }}</span>
          </el-col>
          <el-col :span="12">
            <span>公示日期：</span>
            <span>{{ formatPopoverValue(docManage.releaseDate) }}</span>
          </el-col>
          <el-col :span="12">
            <span>时效性：</span>
            <span>{{ formatPopoverValue(docManage.efficientName) }}</span>
          </el-col>
        </el-row>
      </div>
      <!-- 第二个卡片 -->
      <div class="card article-card" style="height:800px">
        <iframe
          :src="mainUrl"
          width="100%"
          height="100%"
          style="border: none"
        ></iframe>
      </div>
    </div>
  </div>
</template>

<script>
import { getFileData } from "api/modules/knowledgebaseai";

export default {
  name: "KnowledgeDetail",
  data() {
    return {
      searchText: "",
      fileId: "",
      isLoading: true,
      docFile: null,
      docManage: {},
      mainUrl: ""
    };
  },
  created() {
    // 从URL参数中获取fileId
    this.getFileIdFromUrl();
    // 如果有fileId，则请求文件数据
    if (this.fileId) {
      this.fetchFileData();
    }
  },
  methods: {
    /**
     * @description: 从URL参数中获取fileId
     */
    getFileIdFromUrl() {
      // 先尝试从 data 参数中获取
      const urlParams = new URLSearchParams(window.location.search);
      let dataParam = urlParams.get("data");
      if (!dataParam) {
        // hash 里也可能有 data
        const hash = window.location.hash;
        const hashParams = new URLSearchParams(hash.split("?")[1]);
        dataParam = hashParams.get("data");
      }
      if (dataParam) {
        try {
          const dataObj = JSON.parse(decodeURIComponent(dataParam));
          if (dataObj.fileId) {
            this.fileId = dataObj.fileId;
            return;
          }
        } catch (e) {
          // 解析失败，继续走后续逻辑
        }
      }
      // 兼容原有 fileId 直传
      this.fileId = urlParams.get("fileId");
      if (!this.fileId) {
        const hash = window.location.hash;
        const hashParams = new URLSearchParams(hash.split("?")[1]);
        this.fileId = hashParams.get("fileId");
      }
    },

    /**
     * @description: 请求文件数据
     */
    fetchFileData() {
      if (!this.fileId) {
        this.$message.error("缺少文件ID参数");
        return;
      }

      this.isLoading = true;

      getFileData({ fileId: this.fileId })
        .then(response => {
          this.docFile = response.data.docFile;
          this.docManage = response.data.docManage;
          // 判断fileDirectory是否为完整路径
          const fileDirectory = this.docFile.fileDirectory || '';
		  //   const fileName = this.docFile.fileName || '';	--- 历史错误版本取值
          const fileName = this.docFile.serverName || '';
          let filePath = '';
          // 用正则判断fileDirectory结尾是否有.扩展名
          if (/\.[a-zA-Z0-9]+$/.test(fileDirectory)) {
            filePath = fileDirectory;
          } else {
            let dir = fileDirectory;
            if (dir && !dir.endsWith('/')) dir += '/';
            filePath = dir + fileName;
          }
          this.mainUrl =
            "https://wps.52ngs.com/bmfileViewer/onlinePreview?url=" + filePath;
        })
        .catch(error => {
          console.error("请求文件数据失败:", error);
          this.$message.error("获取文件数据失败，请稍后重试");
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    formatPopoverValue(val) {
      if (val === null || val === undefined || val === '' || val === 'null') {
        return '--';
      }
      return val;
    }
  }
};
</script>

<style scoped lang="less">
.detail-bg {
  min-height: 100vh;
  background: #f5f6fa;
}
.detail-banner {
  width: 100vw;
  background: #f7fafd;
  border-bottom: 1px solid #e0e0e0;
  position: relative;
  // Banner背景图片层
  .banner-bg {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
    background: url("https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=1500&q=80")
      center/cover no-repeat;
    opacity: 0.18;
    pointer-events: none;
  }
  // Banner内容层
  .banner-inner {
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    align-items: flex-start;
    height: 285px;
    padding-top: 32px;
    position: relative;
    z-index: 1;
    // logo左上角
    .logo {
      width: 130px;
      height: 40px;
      margin-right: 32px;
      margin-top: 0;
    }
    // 标题和搜索整体居中
    .banner-center {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 40px;
      .banner-title {
        font-size: 32px;
        font-weight: bold;
        color: #234;
        margin-bottom: 16px;
      }
      // 搜索区样式
      .banner-search-row {
        display: flex;
        align-items: center;
        margin-top: 8px;
        // 搜索输入和按钮整体
        .search-group {
          display: flex;
          align-items: center;
          border: 1.5px solid #4666a0;
          border-radius: 6px;
          box-shadow: 0 2px 8px rgba(70, 102, 160, 0.08);
          overflow: hidden;
          // 输入框样式
          .banner-search {
            border: none !important;
            box-shadow: none !important;
            border-radius: 6px 0 0 6px !important;
            height: 44px;
            width: 340px;
            font-size: 15px;
            background: #fff;
            input {
              border: none !important;
              box-shadow: none !important;
              background: #fff;
            }
          }
          // 搜索按钮样式
          .search-btn {
            background: #4666a0;
            color: #fff;
            border: none;
            height: 44px;
            width: 90px;
            font-size: 16px;
            font-weight: 500;
            cursor: pointer;
            transition: background 0.2s;
          }
        }
        // 高级搜索按钮样式
        .advanced-btn {
          margin-left: 12px;
          height: 44px;
          min-width: 110px;
          background: #fff;
          color: #4666a0;
          border: 1.5px solid #4666a0;
          border-radius: 6px;
          font-size: 16px;
          font-weight: 500;
          cursor: pointer;
          transition: background 0.2s, color 0.2s;
          box-shadow: 0 2px 8px rgba(70, 102, 160, 0.08);
        }
      }
    }
  }
}
// 内容区主容器
.detail-main {
  max-width: 1200px;
  margin: 32px auto 0 auto;
  display: flex;
  flex-direction: column;
  gap: 24px;
  background: none;
  box-shadow: none;
  padding: 0;

  // 错误状态样式
  .error-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 60px 20px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);

    i {
      font-size: 48px;
      color: #f56c6c;
      margin-bottom: 16px;
    }

    span {
      font-size: 16px;
      color: #606266;
    }
  }

  // 卡片通用样式
  .card {
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    padding: 32px 40px;
  }
  .meta-card {
    margin-bottom: 0;
  }
}
// 元数据行
.meta-row {
  display: flex;
  flex-wrap: wrap;
  font-size: 14px;
  color: #444;
  margin-bottom: 18px;
  .meta-item {
    flex: 1 1 33%;
    margin-bottom: 6px;
    min-width: 200px;
  }
}
// 修正el-input内部圆角和边框
/deep/.el-input__inner {
  height: 100% !important;
  border-radius: 0px !important;
  border: none !important;
}
</style>
